function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "chronometer",
  transform: "translate(0 0.445)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Caminho_907",
  "data-name": "Caminho 907",
  transform: "translate(0 1.882)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.059,0A7.059,7.059,0,1,1,0,7.059,7.059,7.059,0,0,1,7.059,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 7.058823585510254 1.000003814697266 C 3.717983245849609 1.000003814697266 1.000003814697266 3.717983245849609 1.000003814697266 7.058823585510254 C 1.000003814697266 10.3996639251709 3.717983245849609 13.11764335632324 7.058823585510254 13.11764335632324 C 10.3996639251709 13.11764335632324 13.11764335632324 10.3996639251709 13.11764335632324 7.058823585510254 C 13.11764335632324 3.717983245849609 10.3996639251709 1.000003814697266 7.058823585510254 1.000003814697266 M 7.058823585510254 3.814697265625e-06 C 10.95730400085449 3.814697265625e-06 14.11764335632324 3.160343170166016 14.11764335632324 7.058823585510254 C 14.11764335632324 10.95730400085449 10.95730400085449 14.11764335632324 7.058823585510254 14.11764335632324 C 3.160343170166016 14.11764335632324 3.814697265625e-06 10.95730400085449 3.814697265625e-06 7.058823585510254 C 3.814697265625e-06 3.160343170166016 3.160343170166016 3.814697265625e-06 7.058823585510254 3.814697265625e-06 Z",
  stroke: "none",
  fill: ""
})), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_922",
  "data-name": "Caminho 922",
  d: "M0,0H2.532",
  transform: "translate(5.683 0.055)",
  fill: "none",
  stroke: "",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_919",
  "data-name": "Caminho 919",
  d: "M0,0V1.981",
  transform: "translate(7.004)",
  fill: "none",
  stroke: "",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_916",
  "data-name": "Caminho 916",
  d: "M0,0,2.091,1.871",
  transform: "translate(10.966 2.862)",
  fill: "none",
  stroke: "",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_911",
  "data-name": "Caminho 911",
  d: "M0,0H2.972",
  transform: "translate(9.772 9.647) rotate(180)",
  fill: "none",
  stroke: "",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_912",
  "data-name": "Caminho 912",
  d: "M0,5.176V0",
  transform: "translate(7.018 4.941)",
  fill: "none",
  stroke: "",
  strokeWidth: 1
}));

function SvgChronometer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.118,
    height: 16.445,
    viewBox: "0 0 14.118 16.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChronometer);
export default __webpack_public_path__ + "static/media/chronometer.c2a4862e.svg";
export { ForwardRef as ReactComponent };